/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */

export type InventoryWarehouseType =
  (typeof InventoryWarehouseType)[keyof typeof InventoryWarehouseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InventoryWarehouseType = {
  warehouse: 'warehouse',
  store: 'store',
  distribution_center: 'distribution_center',
  virtual: 'virtual'
} as const;
